import { Component, OnInit, Input } from '@angular/core';

import { UntypedFormGroup } from '@angular/forms';
import { FormService } from '@bayclubs/utils';
import { DropdownMultiselectItem } from '@bayclubs/drop-down';
import { TranslateService } from '@ngx-translate/core';

import { FilterApiService } from '../../../../services/api/filter-api.service';
import { ReportsEventService, ReportType } from '../../reports-event.service';
import { CapacityReportFilter } from '../../../../models/filters/reports-filters.model';
import { FilterDropDownsService } from '../../../../services/filter-dropdowns.service';

@Component({
    selector: 'app-capacity-report-search-criteria',
    templateUrl: './capacity-report-search-criteria.component.html',
    styleUrls: ['./capacity-report-search-criteria.component.scss'],
    standalone: false
})
export class CapacityReportSearchCriteriaComponent implements OnInit {
    @Input()
    public searchForm: UntypedFormGroup;

    public clubDropdownItems: DropdownMultiselectItem[] = [];
    public categorieDropdownItems: DropdownMultiselectItem[] = [];
    public campTypeDropdownItems: DropdownMultiselectItem[] = [];

    public isBusy: boolean = true;

    @Input() public filters: CapacityReportFilter;

    constructor(
        private reportsEvent: ReportsEventService,
        private filtersApi: FilterApiService,
        private filterDropDownsService: FilterDropDownsService
    ) {}

    ngOnInit() {
        this.isBusy = true;
        this.loadFilters();
    }

    public onSubmit() {
        this.reportsEvent.onSearch();
    }

    public isFormValid() {
        return FormService.isFormValid(this.searchForm);
    }

    private loadFilters() {
        this.filtersApi.get(false).subscribe(data => {
            if (data.isSuccess) {
                this.clubDropdownItems = this.filterDropDownsService.createClubDropDownItemsWitId(data.value, this.filters.clubIds);
                this.categorieDropdownItems = this.filterDropDownsService.createCategoriesDropDownItems(
                    data.value,
                    this.filters.categories
                );
                this.campTypeDropdownItems = this.filterDropDownsService.createCampTypeDropDownItems(this.filters.campTypes);

                this.isBusy = false;
            }
        });
    }

    public onClubsChanged(data: Array<DropdownMultiselectItem>) {
        let clubCodes = data.map(x => x.id);

        this.searchForm.controls['clubIds'].setValue(clubCodes);
    }

    public onCategoryChanged(data: Array<DropdownMultiselectItem>) {
        let categories = data.map(x => x.id);

        this.searchForm.controls['categories'].setValue(categories);
    }

    public onCampTypeChanged(data: Array<DropdownMultiselectItem>) {
        const campTypes = data.map(x => x.id);
        this.searchForm.controls['campTypes'].setValue(campTypes);
    }
}
